<template>
  <div class="contact-page">
    <fn-section
      v-if="isAuthenticated && !isSoftLoggedIn"
      constrained="l"
      padding-top="s"
    >
      <fn-headline
        v-if="firstName"
        type="h2"
      >
        {{ $t('forms.contact.authenticated.greeting', { name: firstName }) }}
        <span class="greeting-block">{{ $t('forms.contact.authenticated.greetingText') }}</span>
      </fn-headline>

      <fn-headline
        v-else
        type="h2"
      >
        {{ $t('forms.contact.anonymous') }}
      </fn-headline>

      <div
        v-if="customerId"
        class="customer-data"
      >
        <span> {{ $t('forms.contact.customerId') }} </span>
        <span> {{ customerId }} </span>
      </div>
      <div class="customer-data">
        <span> {{ $t('forms.contact.email') }} </span>
        <span> {{ email }} </span>
      </div>
    </fn-section>

    <fn-cms-section-loader
      v-if="page.content.content_slots.a && page.content.content_slots.a.sections"
      :sections="page.content.content_slots.a.sections"
    />

    <fn-section
      v-if="!isAuthenticated || isSoftLoggedIn"
      constrained="l"
      class="cp-section"
    >
      <fn-button
        class="cp-login-button"
        secondary
        @click="showLoginModal = true"
      >
        {{ $t('forms.login.buttons.submitNow') }}
      </fn-button>
    </fn-section>

    <fn-cms-section-loader
      v-if="page.content.content_slots.b && page.content.content_slots.b.sections"
      :sections="page.content.content_slots.b.sections"
    />

    <fn-modal-login
      v-if="showLoginModal"
      @close="showLoginModal = false"
    />
  </div>
</template>

<script>
export default {
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    showLoginModal: false,
  }),

  computed: {
    ...mapState(useUserStore, {
      user: 'user',
      isAuthenticated: 'getIsAuthenticated',
      isSoftLoggedIn: 'softLogin',
    }),

    redirectTo() {
      return this.$route.path;
    },

    firstName() {
      return this.user?.defaultAddress?.firstName;
    },

    email() {
      return this.user?.displayUid;
    },

    customerId() {
      return this.user?.sapCode;
    },
  },
};
</script>

<style lang="scss" scoped>
.greeting-block {
  display: block;
}

.cp-section {
  :deep(.button) {
    width: 100%;

    @include bp(m) {
      width: auto;
    }
  }
}

.customer-data {
  display: flex;
  font-size: map-get($font-sizes, 'l');

  span {
    margin-right: $pad;

    &:last-child {
      font-weight: bold;
    }
  }
}
</style>
